import type { ReminderGuidance as Guidance } from "../lib/reminderGuidance";
import { ReminderGuidance } from "./ReminderGuidance";

export interface ReminderOptInCardProps {
  onAccept: () => void;
  onDecline: () => void;
  /** Set when this device has to do something first (an iPhone/iPad in a
   * browser tab, or on old iOS) — the card then shows those steps and a
   * single "Got it" instead of "Yes please", since there's nothing the
   * app can turn on yet. */
  guidance?: Guidance | null;
}

/**
 * Sprint-005 C6 — the gentle, non-ambush opt-in prompt (design-spec-
 * today-card.md §4 zero-jargon rule: never "notification"/"push"/
 * "permission" as raw copy). Rendered on Today once
 * `hooks/useReminderOptIn.ts`'s heuristic says so; "Yes please" is the
 * ONLY thing that ever triggers the real browser permission dialog —
 * this card itself asks nothing of the browser.
 */
export function ReminderOptInCard({ onAccept, onDecline, guidance }: ReminderOptInCardProps) {
  return (
    <div class="reminder-prompt-card" role="region" aria-label="Daily reminder">
      <p class="reminder-prompt-text">
        Want a morning reminder of what's due? We'll nudge you once a day.
      </p>
      {guidance ? <ReminderGuidance guidance={guidance} /> : null}
      <div class="reminder-prompt-actions">
        {guidance ? (
          <button type="button" class="primary-btn" onClick={onDecline}>
            Got it
          </button>
        ) : (
          <>
            <button type="button" class="primary-btn" onClick={onAccept}>
              Yes please
            </button>
            <button type="button" class="secondary-btn" onClick={onDecline}>
              Not now
            </button>
          </>
        )}
      </div>
    </div>
  );
}
